import { useState, useEffect, useCallback } from 'react'

export default function useMediaScroll(elementId = 'mediaListFile') {
  const [scrollHeight, setScrollHeight] = useState(0)
  const [clientHeight, setClientHeight] = useState(0)
  const [scrollTop, setScrollTop] = useState(0)

  const handleScroll = useCallback((event) => {
    const scrollTopVal = event.target.scrollTop
    const clientHeightVal = event.target.clientHeight
    const scrollHeightVal = event.target.scrollHeight
    setScrollHeight(scrollHeightVal)
    setClientHeight(clientHeightVal)
    setScrollTop(scrollTopVal)
  }, [])

  useEffect(() => {
    document.getElementById(elementId).scrollTo({ top: 0, behavior: 'smooth' })
    document.getElementById(elementId).addEventListener('scroll', handleScroll)
    return () => {
      document
        .getElementById(elementId)
        ?.removeEventListener('scroll', handleScroll)
    }
  }, [handleScroll])
  return {
    scrollHeight,
    clientHeight,
    scrollTop,
    setScrollTop,
  }
}
